export const MAX_USERNAME_LENGTH = 32;
export const MAX_PASSWORD_LENGTH = 32;
export const MIN_PASSWORD_LENGTH = 8;

const USERNAME_PATTERN = /^[A-Za-z0-9._-]+$/;

export function usernameHasSpaces(value) {
  return /\s/.test(String(value ?? ''));
}

export function validateUsername(value) {
  const text = String(value ?? '');
  if (!text.trim()) return 'Username is required';
  if (usernameHasSpaces(text)) return 'Username cannot contain spaces';
  if (text.length > MAX_USERNAME_LENGTH) {
    return `Username must be at most ${MAX_USERNAME_LENGTH} characters`;
  }
  if (!USERNAME_PATTERN.test(text)) {
    return 'Username may only contain letters, numbers, dots, underscores, and hyphens';
  }
  return null;
}

export function validatePassword(value, { label = 'Password' } = {}) {
  const text = String(value ?? '');
  if (!text) return `${label} is required`;
  if (text.includes('\0')) return `${label} contains invalid characters`;
  if (text.length < MIN_PASSWORD_LENGTH) {
    return `${label} must be at least ${MIN_PASSWORD_LENGTH} characters`;
  }
  if (text.length > MAX_PASSWORD_LENGTH) {
    return `${label} must be at most ${MAX_PASSWORD_LENGTH} characters`;
  }
  return null;
}

export function validatePasswordComplex(value, { label = 'Password' } = {}) {
  const basicError = validatePassword(value, { label });
  if (basicError) return basicError;
  const text = String(value ?? '');
  if (!/[A-Z]/.test(text)) {
    return `${label} must include an uppercase letter`;
  }
  if (!/[a-z]/.test(text)) {
    return `${label} must include a lowercase letter`;
  }
  if (!/\d/.test(text)) {
    return `${label} must include a number`;
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(text)) {
    return `${label} must include a special character`;
  }
  return null;
}